<span class="user-option-placeholder" *ngIf="isPlaceholder; else optionT">{{
  primaryText
}}</span>

<ng-template #optionT>
  <span class="user-option" [class.user-option-compact]="compact">
    <mat-icon class="user-option-icon" aria-hidden="true">{{
      isGroup ? 'group' : 'person'
    }}</mat-icon>

    <span class="user-option-primary">{{ primaryText }}</span>

    <span class="user-option-badge" *ngIf="isGroup">{{
      'General.Group' | translate
    }}</span>

    <span class="user-option-secondary" *ngIf="secondaryText">{{
      secondaryText
    }}</span>

    <span
      class="user-option-warning"
      *ngIf="showWarning"
      [title]="'General.NoPortalAccess' | translate"
    >
      <mat-icon class="user-option-icon" aria-hidden="true">block</mat-icon>
      <span class="user-option-warning-text">{{
        'General.NoPortalAccess' | translate
      }}</span>
    </span>
  </span>
</ng-template>
